import { type vec3 } from 'gl-matrix';

import { type Vector3 } from '@canvas/vector-types';

import { type ColorName } from './colors/color-names.ts';

type MaybeVec3 = { x: number; y: number; z: number } | vec3;

const isVec3 = (input: unknown): input is vec3 => {
  return (Array.isArray(input) || input instanceof Float32Array) && input.length === 3;
};

const normalize = (input: MaybeVec3): vec3 => {
  if (isVec3(input)) {
    return input as vec3;
  }

  return [input.x, input.y, input.z];
};

export const getColorName = (
  input: MaybeVec3,
  swatchColorMap: { [key: string]: Vector3 },
): ColorName => {
  const [r, g, b] = normalize(input);

  const match = Object.entries(swatchColorMap).find(([, color]) => {
    const [cr, cg, cb] = normalize(color);
    return r === cr && g === cg && cb === b;
  });

  return (match?.[0] as ColorName | undefined) ?? 'none';
};
